import React from "react";
import useTheme from "../../../hooks/useTheme";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { Error as ErrorBoundary } from "components";
import layoutHOC from "../../../HOC/layoutHOC";
import config from "constants/config";
import { muiTheme } from "../muiTheme";
import { ThemeProvider } from '../context/ThemeProvider';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { Switch, Route } from "react-router-dom";
import EditorWrapper from "./history-wrapper";

import "./index.scss";
import ConflictsResolution from "../../dashboard/screens/customization/themes/conflicts-resolution";


const EditorLayout = () => {

	const isDark = useTheme();

	return (
		<GoogleReCaptchaProvider reCaptchaKey={config.CAPTCHA_SITE_KEY_V3}>
			<ErrorBoundary>
				<MuiThemeProvider theme={muiTheme(isDark)}>
					<ThemeProvider>
						<Switch>
							<Route path="/editor/:themeId" component={EditorWrapper} />
							<Route path="/customization/themes/:themeId/conflicts" component={ConflictsResolution} />
						</Switch>
					</ThemeProvider>
				</MuiThemeProvider>
			</ErrorBoundary>
		</GoogleReCaptchaProvider>
	)
}

export default layoutHOC(EditorLayout)
